// src/components/utils/shotNumber.js
// (copie le même code aussi dans src/utils/shotNumber.js si tu as un doublon)

export function getShotDisplayNumber(shotNumber, lang, shotPrefixMode) {
  const raw = String(shotNumber || "").trim();
  if (!raw) return "";

  // Supporte :
  // S12, S12-A, S12-AA
  // P12, P12-A
  // SH12, SH12-B, etc.
  const m = raw.match(/^(S|P|SH)?\s*(\d+)(?:-([A-Z]+))?$/i);
  if (!m) return raw;

  const num = m[2];
  const suf = m[3] ? `-${String(m[3]).toUpperCase()}` : "";

  const mode = String(shotPrefixMode || "").toLowerCase();

  // Si "none" => pas de préfixe (juste 12-A)
  if (mode === "none") return `${num}${suf}`;

  // Si on te passe "auto" par erreur => suit la langue UI
  let prefix = mode;
  if (prefix === "auto" || !prefix) {
    prefix = String(lang || "").toLowerCase().startsWith("fr") ? "p" : "sh";
  }

  prefix = prefix.toUpperCase();

  // Sécurité : si quelqu’un force "S"
  if (prefix === "S") return `S${num}${suf}`;

  // P ou SH
  return `${prefix}${num}${suf}`;
}
